import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
import Cache from 'i18next-localstorage-cache'
import LanguageConfig from 'config/Language'

const prefix = 'i18next_res_'
const language = new LanguageConfig(prefix)

// Clears cache to a new request and saves updated language.
language.clearI18nCache()

// i18n configs
i18n
  .use(XHR)
  .use(Cache)
  .init({
    backend: {
      loadPath: `/locales/${language.userLanguage}.json`,
    },
    keySeparator: false,
    nsSeparator: false,
    cache: {
      enabled: true,
      prefix,
    },
  })

export default i18n
